import { render, staticRenderFns } from "./CourseDegree.vue?vue&type=template&id=099bc4f8"
import script from "./CourseDegree.vue?vue&type=script&lang=js"
export * from "./CourseDegree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('099bc4f8')) {
      api.createRecord('099bc4f8', component.options)
    } else {
      api.reload('099bc4f8', component.options)
    }
    module.hot.accept("./CourseDegree.vue?vue&type=template&id=099bc4f8", function () {
      api.rerender('099bc4f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/select/CourseDegree.vue"
export default component.exports